module.exports = __webpack_public_path__ + "static/media/NotoSans-SemiBold.d37a9e1a.woff";